import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type CompanyMenuResponse = {
  title: string;
  link: string;
  adminOnly: boolean;
  isComingSoon: boolean;
  isLocked: boolean;
  tip: string;
}[];

export const companyMenuApiClient = {
  index: async (): Promise<ApiResult<CompanyMenuResponse>> => {
    return await axiosClient.get('/company/menus');
  },
};
